import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';

export const emptyReference = () => ({
  id: `ref-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
  refereeName: '',
  contactNo: '',
  emailId: '',
  designation: '',
  organizationName: '',
  organizationAddress: '',
});

export const mapReferencesFromApi = (rows = []) =>
  (Array.isArray(rows) ? rows : []).map((ref) => ({
    id: ref.id != null ? `ref-${ref.id}` : emptyReference().id,
    refereeName: ref.referee_name || ref.refereeName || '',
    contactNo: ref.contact_no || ref.contactNo || '',
    emailId: ref.email_id || ref.emailId || '',
    designation: ref.designation || '',
    organizationName: ref.organization_name || ref.organizationName || '',
    organizationAddress: ref.organization_address || ref.organizationAddress || '',
  }));

export default function ApplicationReferenceDetails({
  references,
  onChange,
  viewOnly = false,
}) {
  const updateReference = (id, field, value) => {
    onChange(
      references.map((ref) => (ref.id === id ? { ...ref, [field]: value } : ref))
    );
  };

  const addReference = () => {
    onChange([...references, emptyReference()]);
  };

  const removeReference = (id) => {
    onChange(references.filter((ref) => ref.id !== id));
  };

  return (
    <div className="form-section">
      <h2 className="section-title" style={{ marginBottom: '8px' }}>
        Reference Details
      </h2>
      <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '16px' }}>
        Add referee details for this application. You can add multiple references.
      </p>

      {references.length > 0 ? (
        references.map((ref, index) => (
          <div key={ref.id} className="dynamic-entry">
            <div className="entry-header">
              <h3>Reference #{index + 1}</h3>
              {!viewOnly && (
                <button
                  type="button"
                  className="btn-icon btn-delete"
                  onClick={() => removeReference(ref.id)}
                  title="Remove reference"
                >
                  <FontAwesomeIcon icon={faTrash} />
                </button>
              )}
            </div>
            <div className="row">
              <div className="col-md-4 mb-3">
                <label className="form-label">Referee name</label>
                <input
                  type="text"
                  className="input-field"
                  value={ref.refereeName}
                  onChange={(e) => updateReference(ref.id, 'refereeName', e.target.value)}
                  placeholder="Enter referee name"
                  readOnly={viewOnly}
                />
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">Contact no</label>
                <input
                  type="text"
                  className="input-field"
                  value={ref.contactNo}
                  onChange={(e) => updateReference(ref.id, 'contactNo', e.target.value)}
                  placeholder="Enter contact number"
                  readOnly={viewOnly}
                />
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">Email id</label>
                <input
                  type="email"
                  className="input-field"
                  value={ref.emailId}
                  onChange={(e) => updateReference(ref.id, 'emailId', e.target.value)}
                  placeholder="Enter email address"
                  readOnly={viewOnly}
                />
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">Designation</label>
                <input
                  type="text"
                  className="input-field"
                  value={ref.designation}
                  onChange={(e) => updateReference(ref.id, 'designation', e.target.value)}
                  placeholder="Enter designation"
                  readOnly={viewOnly}
                />
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">Organization name</label>
                <input
                  type="text"
                  className="input-field"
                  value={ref.organizationName}
                  onChange={(e) => updateReference(ref.id, 'organizationName', e.target.value)}
                  placeholder="Enter organization name"
                  readOnly={viewOnly}
                />
              </div>
              <div className="col-md-4 mb-3">
                <label className="form-label">Organization address</label>
                <input
                  type="text"
                  className="input-field"
                  value={ref.organizationAddress}
                  onChange={(e) => updateReference(ref.id, 'organizationAddress', e.target.value)}
                  placeholder="Enter organization address"
                  readOnly={viewOnly}
                />
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="no-data-message">
          <p>
            {viewOnly
              ? 'No references added.'
              : 'No references added yet. Click "Add Reference" to begin.'}
          </p>
        </div>
      )}

      {!viewOnly && (
        <div style={{ marginTop: '12px' }}>
          <button type="button" className="btn-primary btn-sm" onClick={addReference}>
            <FontAwesomeIcon icon={faPlus} /> Add Reference
          </button>
        </div>
      )}
    </div>
  );
}
